'use client';

import Image from 'next/image';
import { BLUR_PLACEHOLDER } from '@/lib/componentutills';

type Slide = {
  title: string;
  image?: string;
  slug?: string;
  storyTemplate?: string;
};

type SliderProps = {
  slides?: Slide[];
  intervalMs?: number;
  width?: number | string;
  ratio?: number | string;
  showControls?: boolean;
  className?: string;
};

export default function Slider({
  slides,
  width = '100%',
  ratio = '183 / 280',
  className,
}: SliderProps) {
  const firstSlide = slides?.[0];

  if (!firstSlide) return null;

  const handleClick = () => {
    if (!firstSlide.slug) return;
    window.open(`/${firstSlide.slug}`, '_blank');
  };

  return (
    <div
      className={className}
      style={{ position: 'relative', overflow: 'hidden', width, aspectRatio: ratio }}
    >
      <div
        style={{ position: 'absolute', inset: 0, cursor: firstSlide.slug ? 'pointer' : 'default' }}
        onClick={handleClick}
      >
        <Image
          src={firstSlide.image || 'https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png'}
          alt={firstSlide.title}
          fill
          priority
          sizes={typeof width === 'number' ? `${width}px` : '(max-width: 768px) 100vw, 400px'}
          style={{ objectFit: 'cover' }}
          placeholder="blur"
          blurDataURL={BLUR_PLACEHOLDER}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.25) 50%, transparent)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', left: 12, right: 12, bottom: 12, userSelect: 'none', pointerEvents: 'none' }}>
          <p style={{ color: 'white', fontWeight: 600, fontSize: 14, lineHeight: '18px', textShadow: '0 1px 1px rgba(0,0,0,0.8)', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
            {firstSlide.title}
          </p>
        </div>
      </div>
    </div>
  );
}
